import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
}

export function Button({
  variant = "primary",
  className = "",
  disabled,
  children,
  ...props
}: ButtonProps) {
  const base =
    "h-[51px] rounded-2xl px-4 font-semibold text-base leading-[1.2] w-full flex items-center justify-center gap-1 transition-opacity";
  const variants = {
    primary: "bg-btn-primary text-text-btn",
    secondary: "bg-bg-secondary text-text-primary",
    danger: "bg-system-red text-text-btn",
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
